enum AnimationDelay {
    A200 = '--a-d-200',
    A400 = '--a-d-400',
    A600 = '--a-d-600',
    A800 = '--a-d-800',
    A1S = '--a-d-1000',
}

export default AnimationDelay;
